import { useQuery } from '@tanstack/react-query'
import { fetchPaymentDetail, UsePaymentDetailsParams } from './queries'

export const useGetPaymentDetails = ({
  programId = 0,
  paymentId = '',
}: UsePaymentDetailsParams = {}) => {
  return useQuery({
    queryKey: ['paymentDetails', { programId, paymentId }],
    queryFn: () => fetchPaymentDetail({ programId, paymentId }),
  })
}
